import React from 'react';
import { SubTitle } from '@codeparva/ui-components-library';
import { JumbotronTypes } from '../../jumbotronTypes';
import { FontAwesomeIcon } from '../../../../../../utilities/iconLoader/FontAwesomeIcon';

const Accordion = ({
  title,
  content,
  className,
  closeIcon,
  openIcon,
  variant,
  isActive,
  ...props
}: JumbotronTypes.IAccordion) => {
  return (
    <div className={`accordion-item ${className}`}>
      <div
        {...props}
        className="accordion-title is-flex is-justify-content-space-between is-align-items-center mb-0"
      >
        <SubTitle
          renderAs="h4"
          className={`mb-0 AccordionText ${
            variant === 'multiLocationDropDown'
              ? 'MultiTextSize'
              : 'SingleTextSize'
          }`}
        >
          <>{title}</>
        </SubTitle>
        {isActive ? (
          <FontAwesomeIcon
            iconClassName={closeIcon.iconClassName}
            iconContextProps={{
              className: `${`has-text-${closeIcon?.color} || has-text-primary`}`,
              style: {
                fontSize: closeIcon?.size,
              },
            }}
          />
        ) : (
          <FontAwesomeIcon
            iconClassName={openIcon.iconClassName}
            iconContextProps={{
              className: `${`has-text-${openIcon?.color}`}`,
              style: {
                fontSize: openIcon?.size,
              },
            }}
          />
        )}
      </div>
      {isActive && <div className="accordion-content">{content}</div>}
    </div>
  );
};

export default Accordion;
